import { createContext } from 'react';

export const ScreenSizesContext = createContext(null);
